import * as React from 'react'

import { ContentView } from './Content.view'

export const Content = ({ openPaymentModal }: { openPaymentModal: () => void }) => {
  return <ContentView openModal={openPaymentModal} />
}
